import request from '@/utils/request'

// 访视列表
export function getVisit(query) {
  return request({
    url: '/v1.0/iwrs/visit/all?' + query,
    method: 'get'
  })
}

// 新增访视
export function addVisit(data) {
  return request({
    url: '/v1.0/iwrs/visit/add',
    method: 'post',
    data
  })
}

// 删除访视
export function delVisit(data) {
  return request({
    url: '/v1.0/iwrs/visit/delete',
    method: 'delete',
    data
  })
}

// 编辑访事
export function editVisit(data) {
  return request({
    url: '/v1.0/iwrs/visit/update',
    method: 'put',
    data
  })
}

// 详情
export function detailVisit(query) {
  return request({
    url: '/v1.0/iwrs/visit/detail',
    method: 'get',
    params: query
  })
}
